module.exports = __webpack_public_path__ + "img/logo_ch.58e4bc71.png";